import { useQuery } from "@tanstack/react-query";

import { getPortfolioPositionsTablePreference } from "../services/user-ui-preferences-service";
import { portfolioKeys } from "./queries";

export function usePortfolioPositionsTablePreferences() {
  return useQuery({
    queryKey: portfolioKeys.uiPrefs.portfolioPositionsTable(),
    queryFn: getPortfolioPositionsTablePreference,
    staleTime: 5 * 60_000,
  });
}
